import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Safety() {
  const { t } = useTranslation();

  return (
    <section id="safety" className="scroll-mt-20 py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="rounded-lg border border-accent-200 bg-accent-50 p-6 md:p-8">
          <div className="flex items-start gap-4">
            <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 shrink-0">
              <i className="ri-shield-star-line text-xl"></i>
            </span>
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">{t('safety.title')}</h2>
              <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">{t('safety.p')}</p>
              <Link
                to="/usfans-spreadsheet"
                className="inline-flex items-center gap-2 mt-4 text-sm font-semibold text-accent-700 hover:text-accent-800 cursor-pointer"
              >
                {t('safety.link')}
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}